export type Coordinate = {
  lat: number
  lng: number
}

export const coordinateIsInvalid = (coordinate: Coordinate) => {
  if (coordinate.lat === 0 && coordinate.lng === 0) {
    return false
  } else if (coordinate.lat < -90 || coordinate.lat > 90) {
    return false
  } else if (coordinate.lng < -180 || coordinate.lng > 180) {
    return false
  }
  return true
}
